import React from 'react';

import { Box, Flex, FlexProps } from '@chakra-ui/react';
import {
  Button,
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownSeparator,
  DropdownTrigger,
  Tooltip,
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipTrigger,
} from '@mesh.ai/rabbit';
import { IHeaderParams } from 'ag-grid-community';

import { Overflow } from 'assets/assetsV1/iconComponents';

import { AgGridKebabMenuOptions } from 'uiToolkitV1/AgGridWrapperV2/types';

type Props = IHeaderParams & {
  options: AgGridKebabMenuOptions;
  containerProps?: FlexProps;
};

const KebabMenu = ({ options, containerProps = {} }: Props) => {
  const renderKebabMenu = options?.length;

  if (!renderKebabMenu) {
    return null;
  }

  return (
    <Flex h="100%" w="100%" alignItems="center" justifyContent="center" {...containerProps}>
      <Dropdown>
        <DropdownTrigger asChild>
          <Button variant="text">
            <Overflow width="16px" />
          </Button>
        </DropdownTrigger>
        <DropdownContent className="w-56" align="end">
          {options.map((option, index) => {
            const { label, onClick, Icon, disabled, disabledReason, hasBottomSeparator } = option;
            const IconExists = !!Icon;
            return (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Box w="100%">
                      <DropdownItem
                        onSelect={onClick}
                        disabled={disabled}
                        style={{
                          alignItems: 'center',
                        }}
                      >
                        {/* @ts-expect-error --- */}
                        {IconExists && <Icon mr="8px" color="currentColor" boxSize="16px" />}
                        <span>{label}</span>
                      </DropdownItem>
                      {hasBottomSeparator && <DropdownSeparator />}
                    </Box>
                  </TooltipTrigger>
                  {disabled && disabledReason ? (
                    <TooltipPortal>
                      <TooltipContent>{disabledReason}</TooltipContent>
                    </TooltipPortal>
                  ) : null}
                </Tooltip>
              </TooltipProvider>
            );
          })}
        </DropdownContent>
      </Dropdown>
    </Flex>
  );
};

export { KebabMenu };
